// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2IRnL","dragIcon":"SortableItem_dragIcon__i6Ik4","disabled":"SortableItem_disabled__2hO86"};